import { colors, sizes } from './icons.styles'
import type { AddIcon } from './inline'
import type { IconProps as IconPropsType } from './utils'
import { createIconA11yProps } from './utils'

const utils = {
  createIconA11yProps,
}

export type IconComponent = typeof AddIcon
export type IconProps = IconPropsType
export * from './color'
export * from './inline'
export * from './big'
// homepage icons (landing pages)
export * from './homepage'
// category icons
export * from './category'
// social media icons
export * from './social'

export * from './constants'
export { utils, sizes, colors }
